import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appCampaignListRowMetaInfo]',
})
export class CampaignListRowMetaInfoDirective {
  constructor(public readonly templateRef: TemplateRef<any>) {}
}
